import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-body mt-3 d-flex flex-column justify-content-start align-content-start px-3" }
const _hoisted_2 = { class: "text-start mb-3" }
const _hoisted_3 = { class: "fs-4 fw-bold content-title" }

import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import AccountUserMgmtVue from "@/components/AccountUserMgmt.vue";
// import AccountOnerUserMgmt from "@/components/AccountOnerUserMgmt.vue";
import AccountTeacherMgmt from "@/components/AccountTeacherMgmt.vue";
import CoursesMgmt from "@/components/CoursesMgmt.vue";
import ClassRoomMgmt from "@/components/ClassRoomMgmt.vue";
import { useUserInfoStore } from "@/stores/UserInfoStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'MusicAccountMgmt',
  setup(__props) {

const userInfoStore = useUserInfoStore();

defineComponent({
  components: {
    AccountUserMgmtVue,
    // AccountOnerUserMgmt
  },
});


const { t } = useI18n();



return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)("Account_Mgmt_Music")), 1)
    ]),
    _createVNode(_component_el_tabs, { type: "border-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { label: "帳號設定(學生)" }, {
          default: _withCtx(() => [
            (_unref(userInfoStore).userId == 51)
              ? (_openBlock(), _createBlock(AccountUserMgmtVue, {
                  key: 0,
                  ref: "AccountUserMgmtRef"
                }, null, 512))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_unref(userInfoStore).userId == 51)
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 0,
              label: "帳號設定(老師)"
            }, {
              default: _withCtx(() => [
                (_unref(userInfoStore).userId == 51)
                  ? (_openBlock(), _createBlock(AccountTeacherMgmt, {
                      key: 0,
                      ref: "AccountUserMgmtRef"
                    }, null, 512))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(userInfoStore).userId == 51)
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 1,
              label: _unref(t)('Courses Settings')
            }, {
              default: _withCtx(() => [
                _createVNode(CoursesMgmt)
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (_unref(userInfoStore).userId == 51)
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 2,
              label: "教室設定"
            }, {
              default: _withCtx(() => [
                _createVNode(ClassRoomMgmt)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})